module.exports = __webpack_public_path__ + "img/NotesScreenRe add.f35c7c0f.svg";